module.exports = __webpack_public_path__ + "static/img/41.66b5b275.png";